import { useMutation } from '@tanstack/react-query'
import { submitContactForm, type ContactFormData, type ContactFormResponse } from '../services/contactFormService'

/**
 * Hook para enviar el formulario de contacto usando useMutation
 * El apiClient ya maneja el token Bearer automáticamente desde localStorage
 */
export const useSubmitContactForm = () => {
  return useMutation({
    mutationFn: (data: ContactFormData): Promise<ContactFormResponse> => {
      return submitContactForm(data)
    },
    onSuccess: (data) => {
      console.log('✅ Formulario de contacto enviado exitosamente:', data)
    },
    onError: (error: any) => {
      console.error('❌ Error al enviar el formulario de contacto:', error)
    },
  })
}

export default useSubmitContactForm

